"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpeakerEventData = exports.findPersonById = void 0;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/web.dom-collections.iterator.js");
const findPersonById = (people, id) => {
  const person = people.filter(item => {
    return item.speakerId === id;
  })[0];
  if (!person) {
    throw new Error('No required data');
  }
  return person;
};
exports.findPersonById = findPersonById;
const getSpeakerEventData = (page, scheduleData, speakerId) => {
  if (!(scheduleData !== null && scheduleData !== void 0 && scheduleData.schedules)) return null;
  const results = [];
  for (const day of scheduleData.schedules) {
    for (const event of day.events) {
      if (event.link !== false && event.title && event.abstract && event.speakers && event.speakers.length === 1 && event.speakers[0].role === page.slice(0, -1) && event.speakers[0].speakerId === speakerId) {
        results.push({
          title: event.title || null,
          abstract: event.abstract || null
        });
      }
    }
  }
  return results.length > 0 ? results : null;
};
exports.getSpeakerEventData = getSpeakerEventData;